import { render, staticRenderFns } from "./HealManage.vue?vue&type=template&id=66623f32&scoped=true"
import script from "./HealManage.vue?vue&type=script&lang=js"
export * from "./HealManage.vue?vue&type=script&lang=js"
import style0 from "./HealManage.vue?vue&type=style&index=0&id=66623f32&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66623f32",
  null
  
)

export default component.exports